import React from "react";
import { Container } from "../styled.ts";
import ResultBar from "./ResultBar.tsx";

export const SearchResults = ({ results, onSelect, keyWord:{searchWord} }) => {
  if (!searchWord || !results.length) {
    return <></>;
  }

  const keyWordInLowerCase = searchWord.toLowerCase();
  const filteredResults = results.filter(({ label, id }) =>
    label.toLowerCase().startsWith(keyWordInLowerCase) ||  id.toLowerCase().startsWith(keyWordInLowerCase)
  );

  if (!filteredResults.length) {
    return <></>;
  }
  return (
    <Container
      column
      border="solid 1px #EEEEEE"
      radius="25px"
      gap="10px"
      padding="20px"
      height="auto"
      style={{ overflowY: "auto", maxHeight: "200px" }}
    >
      {filteredResults.map((result) => (
        <ResultBar result={result} onSelect={onSelect}/>
      ))}
    </Container>
  );
};
